import { render } from "./SenderDetail.vue?vue&type=template&id=6997b45d&scoped=true"
import script from "./SenderDetail.vue?vue&type=script&lang=js"
export * from "./SenderDetail.vue?vue&type=script&lang=js"

import "./SenderDetail.vue?vue&type=style&index=0&id=6997b45d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6997b45d"]])

export default __exports__